<template>
	<article :id="id" :class="['dc-post-grid-card', 'person-card']">
		<div ref="cardContentWrapper" class="content-wrapper">
			<div class="content-wrapper__inner">
				<img v-if="image" :src="image.src" :alt="image.alt" :srcset="image.srcset" />
				<div class="content-wrapper__inner__person-info">
					<div>
						<h2 class="content-wrapper__inner__person-info__title">{{ title }}</h2>
						<h3 class="content-wrapper__inner__person-info__position">{{ position }}</h3>
					</div>
					<div>
						<a class="content-wrapper__inner__person-info__phone no-line" v-bind:href="'tel:' + email">{{ phone }}</a>
						<a class="content-wrapper__inner__person-info__email no-line" v-bind:href="'mailto:' + email">{{ email }}</a>
					</div>
				</div>
			</div>

			<div class="content-wrapper__bio-wrapper">
				<p class="card-inner__bio-wrapper__bio">{{ bio }}</p>
			</div>
		</div>
	</article>
</template>

<script>
import NansenCard from './NansenCard.vue';
export default {
	extends: NansenCard,
	props: {
		position: {
			type: String,
			required: false,
		},
		phone: {
			type: String,
			required: false,
		},
		email: {
			type: String,
			required: false,
		},
		bio: {
			type: String,
			required: false,
		}
	},
}
</script>
